import React from 'react';
import Immutable from 'immutable';
import c from 'classnames';
import Truncate from 'react-truncate';
import {
  ImageFromField,
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../../config/constants';

import './style.scss';

const TaxonomyThemeTeaser = ({ entity, large = false }) => {
  const title = entity.getIn(['name', 0, 'value']);
  const mediaItem = entity.getIn(['field_media_item', 0]);
  const langcode = entity.getIn(['langcode', 0, 'value'], 'nl');
  const path = entity.getIn(['paths', langcode]);

  const TeaserClasses = c('TaxonomyThemeTeaser', {
    'TaxonomyThemeTeaser--large': large,
  });

  return (
    <div className={TeaserClasses}>
      <div className="TaxonomyThemeTeaser__wrapper">
        {/* Image */}
        <ImageFromField
          field={mediaItem}
          imageStyles={Immutable.Map({
            [SCREEN_MOBILE]: large ? 'page_hero_image_mobile' : '4_3_mobile',
            [SCREEN_TABLET]: '4_3_mobile',
            [SCREEN_NORMAL]: large ? '2_1_landscape_large' : '4_3',
          })}
        />
        {/* Link */}
        <CoreLink to={path}>
          <div className="TaxonomyThemeTeaser__gradient" />
        </CoreLink>
        {/* Title */}
        <div className="TaxonomyThemeTeaser__title">
          <h3>
            <Truncate lines={2} ellipsis="...">
              {title}
            </Truncate>
          </h3>
        </div>

      </div>
    </div>
  );
};

export default TaxonomyThemeTeaser;
